let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("j59tP")).then(() => parcelRequire('lCKc0'));